class ProductSuggestionService extends BaseService
	@register angular.module 'App.Service'
	@inject 'ProductRepository',
		'Guid'

	initProductSuggestions: (productSuggestions) ->
		productIds = _.pluck(productSuggestions, 'product_id')
		query = @ProductRepository.createQuery()
		query.criteria 'id', 'IN', productIds.join()
		query.with 'product_variants'

		return @ProductRepository
			.getEntities query
			.then (entities) =>
				products = _.indexBy entities, 'id'

				for productSuggestion in productSuggestions
					productSuggestion.name = products[productSuggestion.product_id].name
					productSuggestion.product_variants = products[productSuggestion.product_id].product_variants

				return productSuggestions

	getNewProductSuggestionFromProduct: (product) ->
		return {
			id: @Guid.generate()
			name: product.name
			product_id: product.id
			product_variant_id: null
			product_variants: product.product_variants
			is_new: true
		}
